module.exports = __webpack_public_path__ + "static/media/CoreCapital_positivo.19c40dd7.png";